import { FC } from "react";

import {
  DocumentIcon,
  LockIcon,
  SuccessIcon,
} from "@repo/edtech-assets";
import { useIsMobile } from "@repo/edtech-shared";
import clsx from "clsx";

import {
  LessonType,
  MOBILE_WIDTH,
  useMainContextActions,
  useMainContextValues,
} from "../../../../../../model";
import { getConfig } from "../../../../../../origins";
import { ICON_BY_TYPE } from "../../../model/config";

import st from "./SimpleLessonItem.module.scss";

type Props = {
  nodeId: string,
  materialType: LessonType,
  isDisabledLesson: boolean,
  title: string,
  isPassed: boolean,
  isSubList: boolean,
  closeCourseContentAction?: () => void,
};

export const SimpleLessonItem: FC<Props> = ({
  nodeId,
  materialType,
  isDisabledLesson,
  title,
  isPassed,
  isSubList,
  closeCourseContentAction,
}) => {
  const isMobile = useIsMobile(MOBILE_WIDTH);
  const { showCourseContentHover } = getConfig();

  const {
    lessonNodeIds,
    currentLessonIndex,
  } = useMainContextValues();
  const { setLessonAction } = useMainContextActions();

  const Icon = ICON_BY_TYPE[ materialType ] || DocumentIcon;

  const lessonIndex = lessonNodeIds?.findIndex((lessonNodeId) => lessonNodeId === nodeId);
  const isActive = lessonIndex === currentLessonIndex;

  const onChangeLesson = () => {
    if (isDisabledLesson) return;
    setLessonAction((lessonIndex || 0) + 1);

    if (isMobile) closeCourseContentAction?.();
  };

  return (
    <li
      className={
        clsx(
          st.li,
          isDisabledLesson && st.is_lock,
          isSubList && st.sublist,
          isActive && st.is_active,
          showCourseContentHover && st.background_hover,
        )
      }
      role="button"
      onClick={onChangeLesson}
    >
      <span className={st.icon_wrap}>
        <Icon />
      </span>

      <div className={st.title}>
        <span>{title}</span>
      </div>

      <span className={st.last_icon}>
        {isPassed && <SuccessIcon className={st.success_icon} />}
        {!isPassed && isDisabledLesson && <LockIcon className={st.lock_icon} />}
      </span>
    </li>
  );
};
